import { apiClient } from './client'
import { ApiError } from './errors'

// Matches the backend GET /config payload (the axios interceptor unwraps the
// { status, data } envelope, so response.data is this shape directly). Feature
// flags resolve from SSM server-side and can be toggled without a redeploy.
export interface ClientConfig {
  features: {
    poli_enabled: boolean
    blinkpay_enabled: boolean
    // Whether POST /bank_accounts REJECTS a create with no proof_key. Optional
    // because an older backend does not serve it.
    //
    // The customer SPA does NOT relax its own proof requirement when this is
    // false: the flag exists so the backend stays backwards-compatible with the
    // SPA build that is live during the incident (which sends no proof_key), not
    // as licence to submit a bank account with no AML evidence. AddBankAccount
    // requires the proof unconditionally; ops flip this to true once this build
    // is out so the server enforces it too.
    bank_account_proof_required?: boolean
  }
}

export async function fetchClientConfig(): Promise<ClientConfig> {
  try {
    const response = await apiClient.get<ClientConfig>('config')
    return response.data
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}
